import { createStrictContext } from '../strictContext';

import type { ThemePalette } from './tokens';

export const [useThemePalette, ThemePaletteContext] = createStrictContext<ThemePalette>();
